import '.dw{font-size:1.125rem;}.ssr-plugin'
import '.ft{line-height:1.75rem;}.ssr-plugin'
import '.ci{text-decoration:none;}.ssr-plugin'
import '.g0{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="dw ft"
    >
      {translations.privacySubtitle}{' '}
      <a className="ci g0"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="ci g0"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
